<template>
<div class="login-view">
  <div class="container main-container">
    <Login/>
  </div>
</div>
</template>

<script>
import Login from "../components/Login"
export default {
  name: 'loginPage',
  created() {
    this.$store.commit('clearData');
  },
  components: {
    Login
  },
  data: function() {return {

  }},
}
</script>

<style>
  .login-view{
    display: flex;
    background-color: rgba(211, 99, 0, 0.7);
    background-image: url('../assets/background.jpg');
    box-shadow: inset 0 0 0 1000px rgba(211,99,0,.7);
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
    min-height: 100vh;
  }
  .login-view .card{
  background-size: contain;
  background-repeat: no-repeat;
  background-color: transparent !important;
  background-position: center;
  border: none !important;
  }
  .login-view .main-container{
    background-color: transparent !important;
    min-height: 100%;
    overflow: auto;
    color: #fff;
  }
  .login-view .btn-link{
  color: #fff !important;
  font-size: 14px !important;
  }
</style>
